import { Dialog, DialogOverlay, Spinner } from '@era-ui';

type Props = {
  isOpen: boolean;
};

const LoadingOverlay = (props: Props) => {
  const { isOpen } = props;

  return (
    <Dialog open={isOpen}>
      <DialogOverlay className="bg-black/30">
        <div className="w-full h-screen flex items-end justify-center">
          <Spinner className="m-auto" />
        </div>
      </DialogOverlay>
    </Dialog>
  );
};

export default LoadingOverlay;
